import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { AccessCodeGroupInfo, AccessCodeInfo } from './shared-constants';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

const placeHolderData = { groupCode: null, groupName: 'Choisir une organisation' };

@Injectable()
export class OrganizationsGroupService {
	public selectedGroup$ = new BehaviorSubject(placeHolderData);
	public isGroupSelection = true;
	public isOrganizationSelection = true;

	constructor(private db: SpaqFireDb) {}

	get(search: AccessCodeInfo): Observable<AccessCodeGroupInfo> {
		return this.db.organizationGroup$<AccessCodeGroupInfo>(search.organizationCode, search.groupCode);
	}

	disableGroupSelection() {
		this.isGroupSelection = false;
	}

	enableGroupSelection() {
		this.isGroupSelection = true;
	}

	disableOrganizationSelection() {
		this.isOrganizationSelection = false;
	}

	enableOrganizationSelection() {
		this.isOrganizationSelection = false;
	}

	changeGroup($event) {
		this.selectedGroup$.next($event);
	}

	getAll(organizationCode, placeHolder = false): Observable<any> {
		return this.db.organizationGroupsSnapshot$(organizationCode).pipe(
			map(org =>
				org.map((x: any) => {
					return { ...(x.payload.val() as object), groupId: x.key };
				})
			),
			map(org => [...(placeHolder ? [placeHolderData] : []), ...org])
		);
	}

	async addGroup(organizationCode, form: any) {
		const id = form.groupCode.toUpperCase();
		if (await firstValueFrom(this.getGroupById(organizationCode, id))) {
			return Promise.reject('Cette organisation est déjà présente');
		} else {
			return this.db.setOrganizationGroup(organizationCode, id, {
				...form,
				groupCode: id
			});
		}
	}
	async updateGroup(organizationCode: string, form: any) {
		const id = form.groupCode.toUpperCase();
		await firstValueFrom(this.getGroupById(organizationCode, id));
		if (await firstValueFrom(this.getGroupById(organizationCode, id))) {
			return this.db.updateOrganizationGroup(organizationCode, id, {
				...form,
				organizationCode: organizationCode
			});
		} else {
			return Promise.reject('Cette organisation existe pas');
		}
	}

	getGroupById(organizationCode: string, id: string): Observable<any> {
		return this.db.organizationGroup$<any>(organizationCode, id);
	}
}
